import { SelectData } from '@occc-app/design-system';

import { TimeRangeEnum } from './datetime-range-fields.schema';
import { TimeRangeOption } from './datetime-range-fields.types';

export const TIME_RANGE_OPTIONS: SelectData<TimeRangeOption | ''>[] = [
  { value: '', label: 'Anytime' },
  { value: TimeRangeEnum.enum.LAST_HOUR, label: 'Last Hour' },
  { value: TimeRangeEnum.enum.LAST_6_HOURS, label: 'Last 6 Hours' },
  { value: TimeRangeEnum.enum.LAST_24_HOURS, label: 'Last 24 Hours' },
  { value: TimeRangeEnum.enum.CUSTOM_RANGE, label: 'Custom Range' },
];
